import React from 'react';
import Navbar from './Navbar';
function Layout(props) {
  return <>
    <Navbar />
    <div className='mt-3' style={{width : "92%", margin : "auto"}}>
        {props.children}
    </div>
  </>
}

export default Layout;
